
const environmentStatus = localStorage.getItem('environment');

/**
 * Utility object to handle environment-related functionality.
 * Determines if the application is running in a local environment.
 */
const environment = {

  /**
   * Checks if the application is running in a local environment.
   *
   * The status is determined by the value of the `environment` key stored in `localStorage`.
   * If the value is `'local'`, the method returns `true`.
   *
   * @returns {boolean} `true` if the environment is local, otherwise `false`.
   */
  isLocal() {
    return environmentStatus === 'local';
  }

};

export default environment;